module.exports = __webpack_public_path__ + "img/arrow-down.a391107b.svg";